import * as React from "react";
import { forwardRef } from "react";
const SvgSemicircleDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 148, height: 57, viewBox: "0 0 148 57", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { opacity: 0.15, d: "M74.1001 0C38.5521 0 8.61164 24.2 0 57H20.9283C28.9391 35.4 49.6671 20 74 20C98.3329 20 119.161 35.4 127.072 57H148C139.488 24.2 109.548 0 74.1001 0Z", fill: "#F2F9F8" }));
const ForwardRef = forwardRef(SvgSemicircleDown);
export { ForwardRef as ReactComponent };
